import { render } from "./App.vue?vue&type=template&id=35574c53"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35574c53&lang=css"
script.render = render

export default script